import { _ as re, c as pe } from "./raf-1AcQTkO6.js";
function ye(e, r) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(r);
  for (var a = r; a; ) {
    if (a === e)
      return !0;
    a = a.parentNode;
  }
  return !1;
}
var fe = "data-rc-order", te = "data-rc-priority", ke = "rc-util-key", D = /* @__PURE__ */ new Map();
function be() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.mark;
  return r ? r.startsWith("data-") ? r : "data-".concat(r) : ke;
}
function M(e) {
  if (e.attachTo)
    return e.attachTo;
  var r = document.querySelector("head");
  return r || document.body;
}
function xe(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function ae(e) {
  return Array.from((D.get(e) || e).children).filter(function(r) {
    return r.tagName === "STYLE";
  });
}
function le(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!pe())
    return null;
  var a = r.csp, f = r.prepend, n = r.priority, t = n === void 0 ? 0 : n, d = xe(f), i = d === "prependQueue", u = document.createElement("style");
  u.setAttribute(fe, d), i && t && u.setAttribute(te, "".concat(t)), a != null && a.nonce && (u.nonce = a == null ? void 0 : a.nonce), u.innerHTML = e;
  var s = M(r), g = s.firstChild;
  if (f) {
    if (i) {
      var m = (r.styles || ae(s)).filter(function(y) {
        if (!["prepend", "prependQueue"].includes(y.getAttribute(fe)))
          return !1;
        var w = Number(y.getAttribute(te) || 0);
        return t >= w;
      });
      if (m.length)
        return s.insertBefore(u, m[m.length - 1].nextSibling), u;
    }
    s.insertBefore(u, g);
  } else
    s.appendChild(u);
  return u;
}
function ge(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = M(r);
  return (r.styles || ae(a)).find(function(f) {
    return f.getAttribute(be(r)) === e;
  });
}
function qe(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = ge(e, r);
  if (a) {
    var f = M(r);
    f.removeChild(a);
  }
}
function Ae(e, r) {
  var a = D.get(e);
  if (!a || !ye(document, a)) {
    var f = le("", r), n = f.parentNode;
    D.set(e, n), e.removeChild(f);
  }
}
function Ue(e, r) {
  var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, f = M(a), n = ae(f), t = re(re({}, a), {}, {
    styles: n
  });
  Ae(f, t);
  var d = ge(r, t);
  if (d) {
    var i, u;
    if ((i = t.csp) !== null && i !== void 0 && i.nonce && d.nonce !== ((u = t.csp) === null || u === void 0 ? void 0 : u.nonce)) {
      var s;
      d.nonce = (s = t.csp) === null || s === void 0 ? void 0 : s.nonce;
    }
    return d.innerHTML !== e && (d.innerHTML = e), d;
  }
  var g = le(e, t);
  return g.setAttribute(be(t), r), g;
}
function c(e, r) {
  Se(e) && (e = "100%");
  var a = Me(e);
  return e = r === 360 ? e : Math.min(r, Math.max(0, parseFloat(e))), a && (e = parseInt(String(e * r), 10) / 100), Math.abs(e - r) < 1e-6 ? 1 : (r === 360 ? e = (e < 0 ? e % r + r : e % r) / parseFloat(String(r)) : e = e % r / parseFloat(String(r)), e);
}
function Le(e) {
  return Math.min(1, Math.max(0, e));
}
function Se(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Me(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function we(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function k(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function l(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function Ce(e, r, a) {
  return {
    r: c(e, 255) * 255,
    g: c(r, 255) * 255,
    b: c(a, 255) * 255
  };
}
function Qe(e, r, a) {
  e = c(e, 255), r = c(r, 255), a = c(a, 255);
  var f = Math.max(e, r, a), n = Math.min(e, r, a), t = 0, d = 0, i = (f + n) / 2;
  if (f === n)
    d = 0, t = 0;
  else {
    var u = f - n;
    switch (d = i > 0.5 ? u / (2 - f - n) : u / (f + n), f) {
      case e:
        t = (r - a) / u + (r < a ? 6 : 0);
        break;
      case r:
        t = (a - e) / u + 2;
        break;
      case a:
        t = (e - r) / u + 4;
        break;
    }
    t /= 6;
  }
  return { h: t, s: d, l: i };
}
function C(e, r, a) {
  return a < 0 && (a += 1), a > 1 && (a -= 1), a < 1 / 6 ? e + (r - e) * (6 * a) : a < 1 / 2 ? r : a < 2 / 3 ? e + (r - e) * (2 / 3 - a) * 6 : e;
}
function Fe(e, r, a) {
  var f, n, t;
  if (e = c(e, 360), r = c(r, 100), a = c(a, 100), r === 0)
    n = a, t = a, f = a;
  else {
    var d = a < 0.5 ? a * (1 + r) : a + r - a * r, i = 2 * a - d;
    f = C(i, d, e + 1 / 3), n = C(i, d, e), t = C(i, d, e - 1 / 3);
  }
  return { r: f * 255, g: n * 255, b: t * 255 };
}
function Te(e, r, a) {
  e = c(e, 255), r = c(r, 255), a = c(a, 255);
  var f = Math.max(e, r, a), n = Math.min(e, r, a), t = 0, d = f, i = f - n, u = f === 0 ? 0 : i / f;
  if (f === n)
    t = 0;
  else {
    switch (f) {
      case e:
        t = (r - a) / i + (r < a ? 6 : 0);
        break;
      case r:
        t = (a - e) / i + 2;
        break;
      case a:
        t = (e - r) / i + 4;
        break;
    }
    t /= 6;
  }
  return { h: t, s: u, v: d };
}
function De(e, r, a) {
  e = c(e, 360) * 6, r = c(r, 100), a = c(a, 100);
  var f = Math.floor(e), n = e - f, t = a * (1 - r), d = a * (1 - n * r), i = a * (1 - (1 - n) * r), u = f % 6, s = [a, d, t, t, i, a][u], g = [i, a, a, d, t, t][u], m = [t, t, i, a, a, d][u];
  return { r: s * 255, g: g * 255, b: m * 255 };
}
function Ee(e, r, a, f) {
  var n = [
    l(Math.round(e).toString(16)),
    l(Math.round(r).toString(16)),
    l(Math.round(a).toString(16))
  ];
  return f && n[0].startsWith(n[0].charAt(1)) && n[1].startsWith(n[1].charAt(1)) && n[2].startsWith(n[2].charAt(1)) ? n[0].charAt(0) + n[1].charAt(0) + n[2].charAt(0) : n.join("");
}
function Ve(e, r, a, f, n) {
  var t = [
    l(Math.round(e).toString(16)),
    l(Math.round(r).toString(16)),
    l(Math.round(a).toString(16)),
    l(ve(f))
  ];
  return n && t[0].startsWith(t[0].charAt(1)) && t[1].startsWith(t[1].charAt(1)) && t[2].startsWith(t[2].charAt(1)) && t[3].startsWith(t[3].charAt(1)) ? t[0].charAt(0) + t[1].charAt(0) + t[2].charAt(0) + t[3].charAt(0) : t.join("");
}
function Ye(e, r, a, f) {
  var n = [
    l(ve(f)),
    l(Math.round(e).toString(16)),
    l(Math.round(r).toString(16)),
    l(Math.round(a).toString(16))
  ];
  return n.join("");
}
function ve(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function ne(e) {
  return o(e) / 255;
}
function o(e) {
  return parseInt(e, 16);
}
function Ge(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var ie = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function p(e) {
  var r = { r: 0, g: 0, b: 0 }, a = 1, f = null, n = null, t = null, d = !1, i = !1;
  return typeof e == "string" && (e = Pe(e)), typeof e == "object" && (v(e.r) && v(e.g) && v(e.b) ? (r = Ce(e.r, e.g, e.b), d = !0, i = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : v(e.h) && v(e.s) && v(e.v) ? (f = k(e.s), n = k(e.v), r = De(e.h, f, n), d = !0, i = "hsv") : v(e.h) && v(e.s) && v(e.l) && (f = k(e.s), t = k(e.l), r = Fe(e.h, f, t), d = !0, i = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (a = e.a)), a = we(a), {
    ok: d,
    format: e.format || i,
    r: Math.min(255, Math.max(r.r, 0)),
    g: Math.min(255, Math.max(r.g, 0)),
    b: Math.min(255, Math.max(r.b, 0)),
    a
  };
}
var Re = "[-\\+]?\\d+%?", Ne = "[-\\+]?\\d*\\.\\d+%?", h = "(?:".concat(Ne, ")|(?:").concat(Re, ")"), F = "[\\s|\\(]+(".concat(h, ")[,|\\s]+(").concat(h, ")[,|\\s]+(").concat(h, ")\\s*\\)?"), T = "[\\s|\\(]+(".concat(h, ")[,|\\s]+(").concat(h, ")[,|\\s]+(").concat(h, ")[,|\\s]+(").concat(h, ")\\s*\\)?"), b = {
  CSS_UNIT: new RegExp(h),
  rgb: new RegExp("rgb" + F),
  rgba: new RegExp("rgba" + T),
  hsl: new RegExp("hsl" + F),
  hsla: new RegExp("hsla" + T),
  hsv: new RegExp("hsv" + F),
  hsva: new RegExp("hsva" + T),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Pe(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var r = !1;
  if (ie[e])
    e = ie[e], r = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var a = b.rgb.exec(e);
  return a ? { r: a[1], g: a[2], b: a[3] } : (a = b.rgba.exec(e), a ? { r: a[1], g: a[2], b: a[3], a: a[4] } : (a = b.hsl.exec(e), a ? { h: a[1], s: a[2], l: a[3] } : (a = b.hsla.exec(e), a ? { h: a[1], s: a[2], l: a[3], a: a[4] } : (a = b.hsv.exec(e), a ? { h: a[1], s: a[2], v: a[3] } : (a = b.hsva.exec(e), a ? { h: a[1], s: a[2], v: a[3], a: a[4] } : (a = b.hex8.exec(e), a ? {
    r: o(a[1]),
    g: o(a[2]),
    b: o(a[3]),
    a: ne(a[4]),
    format: r ? "name" : "hex8"
  } : (a = b.hex6.exec(e), a ? {
    r: o(a[1]),
    g: o(a[2]),
    b: o(a[3]),
    format: r ? "name" : "hex"
  } : (a = b.hex4.exec(e), a ? {
    r: o(a[1] + a[1]),
    g: o(a[2] + a[2]),
    b: o(a[3] + a[3]),
    a: ne(a[4] + a[4]),
    format: r ? "name" : "hex8"
  } : (a = b.hex3.exec(e), a ? {
    r: o(a[1] + a[1]),
    g: o(a[2] + a[2]),
    b: o(a[3] + a[3]),
    format: r ? "name" : "hex"
  } : !1)))))))));
}
function v(e) {
  return !!b.CSS_UNIT.exec(String(e));
}
var x = 2, de = 0.16, He = 0.05, Ie = 0.05, Oe = 0.15, he = 5, me = 4, je = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function ue(e) {
  var r = e.r, a = e.g, f = e.b, n = Te(r, a, f);
  return {
    h: n.h * 360,
    s: n.s,
    v: n.v
  };
}
function A(e) {
  var r = e.r, a = e.g, f = e.b;
  return "#".concat(Ee(r, a, f, !1));
}
function Be(e, r, a) {
  var f = a / 100, n = {
    r: (r.r - e.r) * f + e.r,
    g: (r.g - e.g) * f + e.g,
    b: (r.b - e.b) * f + e.b
  };
  return n;
}
function ce(e, r, a) {
  var f;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? f = a ? Math.round(e.h) - x * r : Math.round(e.h) + x * r : f = a ? Math.round(e.h) + x * r : Math.round(e.h) - x * r, f < 0 ? f += 360 : f >= 360 && (f -= 360), f;
}
function se(e, r, a) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var f;
  return a ? f = e.s - de * r : r === me ? f = e.s + de : f = e.s + He * r, f > 1 && (f = 1), a && r === he && f > 0.1 && (f = 0.1), f < 0.06 && (f = 0.06), Number(f.toFixed(2));
}
function oe(e, r, a) {
  var f;
  return a ? f = e.v + Ie * r : f = e.v - Oe * r, f > 1 && (f = 1), Number(f.toFixed(2));
}
function Ke(e) {
  for (var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = [], f = p(e), n = he; n > 0; n -= 1) {
    var t = ue(f), d = A(p({
      h: ce(t, n, !0),
      s: se(t, n, !0),
      v: oe(t, n, !0)
    }));
    a.push(d);
  }
  a.push(A(f));
  for (var i = 1; i <= me; i += 1) {
    var u = ue(f), s = A(p({
      h: ce(u, i),
      s: se(u, i),
      v: oe(u, i)
    }));
    a.push(s);
  }
  return r.theme === "dark" ? je.map(function(g) {
    var m = g.index, y = g.opacity, w = A(Be(p(r.backgroundColor || "#141414"), p(a[m]), y * 100));
    return w;
  }) : a;
}
var ze = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, E = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
E.primary = E[5];
var R = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
R.primary = R[5];
var N = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
N.primary = N[5];
var P = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
P.primary = P[5];
var H = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
H.primary = H[5];
var I = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
I.primary = I[5];
var O = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
O.primary = O[5];
var j = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
j.primary = j[5];
var B = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
B.primary = B[5];
var W = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
W.primary = W[5];
var q = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
q.primary = q[5];
var U = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
U.primary = U[5];
var S = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
S.primary = S[5];
var Ze = S, Je = {
  red: E,
  volcano: R,
  orange: N,
  gold: P,
  yellow: H,
  lime: I,
  green: O,
  cyan: j,
  blue: B,
  geekblue: W,
  purple: q,
  magenta: U,
  grey: S
}, L = ["#2a1215", "#431418", "#58181c", "#791a1f", "#a61d24", "#d32029", "#e84749", "#f37370", "#f89f9a", "#fac8c3"];
L.primary = L[5];
var Q = ["#2b1611", "#441d12", "#592716", "#7c3118", "#aa3e19", "#d84a1b", "#e87040", "#f3956a", "#f8b692", "#fad4bc"];
Q.primary = Q[5];
var V = ["#2b1d11", "#442a11", "#593815", "#7c4a15", "#aa6215", "#d87a16", "#e89a3c", "#f3b765", "#f8cf8d", "#fae3b7"];
V.primary = V[5];
var Y = ["#2b2111", "#443111", "#594214", "#7c5914", "#aa7714", "#d89614", "#e8b339", "#f3cc62", "#f8df8b", "#faedb5"];
Y.primary = Y[5];
var G = ["#2b2611", "#443b11", "#595014", "#7c6e14", "#aa9514", "#d8bd14", "#e8d639", "#f3ea62", "#f8f48b", "#fafab5"];
G.primary = G[5];
var K = ["#1f2611", "#2e3c10", "#3e4f13", "#536d13", "#6f9412", "#8bbb11", "#a9d134", "#c9e75d", "#e4f88b", "#f0fab5"];
K.primary = K[5];
var z = ["#162312", "#1d3712", "#274916", "#306317", "#3c8618", "#49aa19", "#6abe39", "#8fd460", "#b2e58b", "#d5f2bb"];
z.primary = z[5];
var Z = ["#112123", "#113536", "#144848", "#146262", "#138585", "#13a8a8", "#33bcb7", "#58d1c9", "#84e2d8", "#b2f1e8"];
Z.primary = Z[5];
var J = ["#111a2c", "#112545", "#15325b", "#15417e", "#1554ad", "#1668dc", "#3c89e8", "#65a9f3", "#8dc5f8", "#b7dcfa"];
J.primary = J[5];
var X = ["#131629", "#161d40", "#1c2755", "#203175", "#263ea0", "#2b4acb", "#5273e0", "#7f9ef3", "#a8c1f8", "#d2e0fa"];
X.primary = X[5];
var $ = ["#1a1325", "#24163a", "#301c4d", "#3e2069", "#51258f", "#642ab5", "#854eca", "#ab7ae0", "#cda8f0", "#ebd7fa"];
$.primary = $[5];
var _ = ["#291321", "#40162f", "#551c3b", "#75204f", "#a02669", "#cb2b83", "#e0529c", "#f37fb7", "#f8a8cc", "#fad2e3"];
_.primary = _[5];
var ee = ["#151515", "#1f1f1f", "#2d2d2d", "#393939", "#494949", "#5a5a5a", "#6a6a6a", "#7b7b7b", "#888888", "#969696"];
ee.primary = ee[5];
var Xe = {
  red: L,
  volcano: Q,
  orange: V,
  gold: Y,
  yellow: G,
  lime: K,
  green: z,
  cyan: Z,
  blue: J,
  geekblue: X,
  purple: $,
  magenta: _,
  grey: ee
};
export {
  Z as A,
  W as B,
  X as C,
  P as D,
  Y as E,
  Ze as F,
  O as G,
  z as H,
  S as I,
  ee as J,
  I as K,
  K as L,
  U as M,
  _ as N,
  N as O,
  V as P,
  Xe as Q,
  Je as R,
  ze as S,
  q as T,
  $ as U,
  E as V,
  L as W,
  R as X,
  Q as Y,
  H as Z,
  G as _,
  we as a,
  B as b,
  Te as c,
  Qe as d,
  Ee as e,
  Ve as f,
  Ke as g,
  Le as h,
  Ge as i,
  p as j,
  c as k,
  Ye as l,
  k as m,
  ie as n,
  ve as o,
  ne as p,
  Fe as q,
  qe as r,
  De as s,
  v as t,
  Ue as u,
  o as v,
  Ce as w,
  Pe as x,
  J as y,
  j as z
};
//# sourceMappingURL=presets-P0FA1xhk.js.map
